const GoogleMap = () => {
    (function ($) {

        var currentInfoWindow;

        function initMap($el) {
            var $markers = $el.find('.marker');
            var mapArgs = {
                zoom: $el.data('zoom') || 16,
                mapTypeId: google.maps.MapTypeId.ROADMAP
            };
            var map = new google.maps.Map($el[0], mapArgs);
            map.markers = [];
            $markers.each(function () {
                initMarker($(this), map);
            });
            centerMap(map);
            return map;
        }

        function initMarker($marker, map) {
            var lat = $marker.data('lat');
            var lng = $marker.data('lng');
            var latLng = {
                lat: parseFloat(lat),
                lng: parseFloat(lng)
            };
            var marker = new google.maps.Marker({
                position: latLng,
                map: map
            });
            map.markers.push(marker);
            
            if ($marker.html()) {
                var infowindow = new google.maps.InfoWindow({
                    content: $marker.html()
                });

                google.maps.event.addListener(marker, 'click', function () {
                    // Close the currently open info window, if any
                    if (currentInfoWindow) {
                        currentInfoWindow.close();
                    }

                    // Open the new info window
                    infowindow.open(map, marker);

                    // Set the currentInfoWindow to the newly opened one
                    currentInfoWindow = infowindow;
                });
            }
        }

        function centerMap(map) {
            var bounds = new google.maps.LatLngBounds();
            map.markers.forEach(function (marker) {
                bounds.extend({
                    lat: marker.position.lat(),
                    lng: marker.position.lng()
                });
            });

            if (map.markers.length === 1) {
                map.setCenter(bounds.getCenter());
                google.maps.event.trigger(map.markers[0], 'click');
            } else {
                map.fitBounds(bounds);
            }
        }

        $(document).ready(function () {
            $('.acf-map').each(function () {
                var map = initMap($(this));
            });
        });

    })(jQuery);
}

export default GoogleMap;
